import { useState, useEffect } from "react";

const GOOGLE_MAPS_URL =
  "https://www.google.com/maps/place/ThermalXpert/@40.654121,-74.0092819,832m/data=!3m1!1e3!4m8!3m7!1s0x89c25b5176835097:0x432d4ff05e38bcd5!8m2!3d40.654117!4d-74.006707!9m1!1b1!16s%2Fg%2F11vwn14_zc?entry=ttu";

const reviews = [
  {
    id: 1,
    name: "Debra Jeffreys-Glass",
    role: "2 reviews",
    rating: 5,
    text: "The diagnostic visit by Miri and Nick was professional and thorough. I felt reassured by their explanation of the issues and am confident that they can address the ongoing issues with our Bosch boiler.",
    timeAgo: "2 months ago",
    avatar: "https://lh3.googleusercontent.com/a-/ALV-UjXOhPGxscVp-qYMVvaSAJh_42nU1eJQCu4JZp2IQiotbW2PICbl=w36-h36-p-rp-mo-br100",
    initials: "DJ",
    color: "#2d7ab5",
    hasOwnerReply: false,
    ownerReply: "",
  },
  {
    id: 2,
    name: "alina bucur",
    role: "Local Guide · 25 reviews · 1 photo",
    rating: 5,
    text: "Amazing experience, my HVAC unit works perfect now. Thank you!",
    timeAgo: "4 months ago",
    avatar: "",
    initials: "AB",
    color: "#1a5f8a",
    hasOwnerReply: false,
    ownerReply: "",
  },
  {
    id: 3,
    name: "Gëzim Ibroçi",
    role: "Local Guide · 26 reviews · 82 photos",
    rating: 5,
    text: "ThermalXpert provided exceptional service. The technicians were highly skilled, efficient, and ensured our cooling & heating system was functioning properly. The technician explained everything clearly and thoroughly. The quality of work was exceptional and the value for money was excellent. I am very satisfied with their service.",
    timeAgo: "1 year ago",
    avatar: "https://lh3.googleusercontent.com/a-/ALV-UjWPZCso0Md-MvXVRVNFOvMuQsSgUhAR25JrR1BZwxrbkaZklxK8=w36-h36-p-rp-mo-ba3-br100",
    initials: "GI",
    color: "#4a9fd4",
    hasOwnerReply: false,
    ownerReply: "",
  },
  {
    id: 4,
    name: "zachary model",
    role: "12 reviews",
    rating: 5,
    text: "Replaced 2 ClimateMaster HVAC units. Highly knowledgeable lead technician. Excellent communication and service from start to finish!",
    timeAgo: "8 months ago",
    avatar: "",
    initials: "ZM",
    color: "#2d7ab5",
    hasOwnerReply: true,
    ownerReply: "Thanks Zach. We appreciate your kind words.",
  },
  {
    id: 5,
    name: "Ozzie Lunja",
    role: "7 reviews · 5 photos",
    rating: 5,
    text: "ThermalXpert was extremely thorough and transparent with my boiler issues. Called me to show me what the issue was so I could see it for myself, which often doesn't happen with contractors! Gave me a few options regarding my system (steam boiler). Didn't push the most expensive option. Was clean in his install and performed a full test of the system the next day to ensure the unit was performing efficiently. Would highly recommend!",
    timeAgo: "1 year ago",
    avatar: "",
    initials: "OL",
    color: "#1a5f8a",
    hasOwnerReply: false,
    ownerReply: "",
  },
  {
    id: 6,
    name: "valdet huseinovic",
    role: "2 reviews",
    rating: 5,
    text: "I recently had the pleasure of working with ThermalXpert, and I couldn't be more impressed with their service. From the initial consultation to the final installation, their team was professional, punctual, and incredibly knowledgeable. Give them a try if you're interested in quality work!",
    timeAgo: "1 year ago",
    avatar: "",
    initials: "VH",
    color: "#4a9fd4",
    hasOwnerReply: false,
    ownerReply: "",
  },
];

function StarRow({ count }: { count: number }) {
  return (
    <div className="flex gap-0.5">
      {Array.from({ length: 5 }).map((_, i) => (
        <i
          key={i}
          className={i < count ? "ri-star-fill" : "ri-star-line"}
          style={{ color: i < count ? "#f59e0b" : "#d1d5db", fontSize: "13px" }}
        />
      ))}
    </div>
  );
}

function Avatar({ review }: { review: (typeof reviews)[0] }) {
  const [imgError, setImgError] = useState(false);
  if (review.avatar && !imgError) {
    return (
      <img
        src={review.avatar}
        alt={review.name}
        onError={() => setImgError(true)}
        className="w-11 h-11 rounded-xl object-cover flex-shrink-0"
      />
    );
  }
  return (
    <div
      className="w-11 h-11 rounded-xl flex items-center justify-center text-white text-sm font-black flex-shrink-0"
      style={{ background: review.color }}
    >
      {review.initials}
    </div>
  );
}

export default function ReviewsSection() {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);

  const visibleCount = 3;
  const total = reviews.length;

  const goTo = (idx: number) => {
    if (animating) return;
    setAnimating(true);
    setCurrent(idx);
    setTimeout(() => setAnimating(false), 350);
  };

  const prev = () => goTo((current - 1 + total) % total);
  const next = () => goTo((current + 1) % total);

  useEffect(() => {
    const t = setInterval(next, 5500);
    return () => clearInterval(t);
  }, [current]);

  const visibleIdxs = Array.from({ length: visibleCount }, (_, i) => (current + i) % total);

  return (
    <section
      className="w-full relative overflow-hidden"
      style={{ background: "linear-gradient(135deg,#0d2850 0%,#1a5f8a 50%,#0d2850 100%)" }}
    >
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: "radial-gradient(circle,rgba(255,255,255,0.04) 1px,transparent 1px)",
          backgroundSize: "28px 28px",
        }}
      />
      <div
        className="absolute top-0 left-0 right-0 h-px"
        style={{ background: "linear-gradient(90deg,transparent,rgba(74,159,212,0.6),transparent)" }}
      />

      <div className="max-w-7xl mx-auto px-8 py-20 relative z-10">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <div
              className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-widest mb-4"
              style={{
                background: "rgba(74,159,212,0.2)",
                color: "#7dd3fc",
                border: "1px solid rgba(74,159,212,0.4)",
              }}
            >
              <i className="ri-star-fill" style={{ color: "#f59e0b" }}></i>
              Google Reviews
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-white leading-tight">
              Trusted by NYC
              <br />
              <span style={{ color: "rgba(255,255,255,0.55)" }}>Building Managers</span>
            </h2>
          </div>

          <div
            className="flex items-center gap-4 px-6 py-4 rounded-2xl flex-shrink-0 self-start md:self-auto"
            style={{ background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.15)" }}
          >
            <div className="flex flex-col items-center">
              <span className="text-3xl font-black text-white">5.0</span>
              <StarRow count={5} />
              <span className="text-xs text-white/50 mt-1">Google Rating</span>
            </div>
            <div className="w-px h-12 bg-white/10" />
            <div className="flex flex-col items-center">
              <span className="text-3xl font-black text-white">26+</span>
              <span className="text-xs text-white/50 mt-1.5">Reviews</span>
            </div>
          </div>
        </div>

        {/* Cards */}
        <div
          className="grid grid-cols-1 md:grid-cols-3 gap-5"
          style={{ opacity: animating ? 0 : 1, transition: "opacity 0.35s ease" }}
        >
          {visibleIdxs.map((idx) => {
            const r = reviews[idx];
            return (
              <div
                key={r.id}
                className="flex flex-col gap-4 p-6 rounded-2xl"
                style={{
                  background: "rgba(255,255,255,0.07)",
                  border: "1px solid rgba(255,255,255,0.12)",
                  backdropFilter: "blur(12px)",
                }}
              >
                <div className="flex items-center gap-3">
                  <Avatar review={r} />
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-black text-white truncate">{r.name}</p>
                    <p className="text-xs text-white/50 truncate">{r.role}</p>
                  </div>
                  <div
                    className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 text-sm font-black"
                    style={{ background: "rgba(255,255,255,0.12)", color: "#fff" }}
                  >
                    G
                  </div>
                </div>

                <div className="flex items-center justify-between">
                  <StarRow count={r.rating} />
                  <span className="text-xs text-white/40">{r.timeAgo}</span>
                </div>

                <p className="text-sm text-white/75 leading-relaxed flex-1">"{r.text}"</p>

                {r.hasOwnerReply && r.ownerReply && (
                  <div
                    className="rounded-xl p-3 text-xs text-white/60 leading-relaxed"
                    style={{ background: "rgba(74,159,212,0.1)", border: "1px solid rgba(74,159,212,0.2)" }}
                  >
                    <span className="font-bold text-white/80 block mb-1">Owner reply:</span>
                    {r.ownerReply}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Navigation */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6 mt-10">
          <div className="flex items-center gap-2">
            {reviews.map((_, i) => (
              <button
                key={i}
                onClick={() => goTo(i)}
                className="rounded-full transition-all duration-300 cursor-pointer"
                style={{
                  width: i === current ? "28px" : "7px",
                  height: "7px",
                  background: i === current ? "#4a9fd4" : "rgba(255,255,255,0.25)",
                }}
              />
            ))}
          </div>

          <div className="flex items-center gap-3">
            <a
              href={GOOGLE_MAPS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-bold transition-all hover:scale-105"
              style={{
                background: "rgba(255,255,255,0.12)",
                border: "1px solid rgba(255,255,255,0.2)",
                color: "#fff",
              }}
            >
              <i className="ri-google-fill" style={{ fontSize: "15px" }}></i>
              View on Google
            </a>
            <button
              onClick={prev}
              className="w-11 h-11 flex items-center justify-center rounded-xl cursor-pointer transition-all hover:scale-105"
              style={{
                background: "rgba(255,255,255,0.1)",
                border: "1px solid rgba(255,255,255,0.2)",
                color: "#fff",
              }}
            >
              <i className="ri-arrow-left-line"></i>
            </button>
            <button
              onClick={next}
              className="w-11 h-11 flex items-center justify-center rounded-xl cursor-pointer transition-all hover:scale-105"
              style={{ background: "linear-gradient(135deg,#4a9fd4,#2d7ab5)", color: "#fff" }}
            >
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 pointer-events-none" style={{ height: "60px" }}>
        <svg viewBox="0 0 1440 60" preserveAspectRatio="none" className="w-full h-full" fill="#f7fbff">
          <path d="M0,30 C480,60 960,0 1440,30 L1440,60 L0,60 Z" />
        </svg>
      </div>
    </section>
  );
}
